import { objectWithKeys } from './objectWithKeys';
import { objectWithoutKeys } from './objectWithoutKeys';
import type { Entity, EntityMap, RejectedError } from './types';

/**
 * Adds these IDs to the map of pending entities, and removes them from the map of fulfilled or rejected entities.
 */
type MoveToPending = <T extends Entity>(state: EntityMap<T>, ids: T['id'][]) => EntityMap<T>;
export const moveToPending: MoveToPending = (state, ids) => {
  const newPending = objectWithKeys<boolean>(state.pending.byId, ids, true);
  const newRejected = objectWithoutKeys<RejectedError>(state.rejected.byId, ids);
  const newFulfilled = objectWithoutKeys(state.fulfilled.byId, ids);

  return {
    ...state,
    pending: {
      ...state.pending,
      byId: newPending,
    },
    rejected: {
      ...state.rejected,
      byId: newRejected,
    },
    fulfilled: {
      ...state.fulfilled,
      byId: newFulfilled,
    },
  };
};

/**
 * Adds this ID to the map of pending entities if it is not already in the map of fulfilled entities.
 */
type MoveToPendingIfNotFulfilled = <T extends Entity>(state: EntityMap<T>, id: T['id']) => EntityMap<T>;
export const moveToPendingIfNotFulfilled: MoveToPendingIfNotFulfilled = (state, id) => {
  if (Object.prototype.hasOwnProperty.call(state.fulfilled.byId, id)) {
    return state;
  }

  return moveToPending(state, [id]);
};
